module.exports = __webpack_public_path__ + "img/upload_bg_04.04794fa6.png";